/**
 * @fileoverview Data Phase — parent route
 *
 * Purpose: Layout shell for the Data phase (sidebar label "Data"; URL
 * segment kept as `/summaries` to avoid breaking deep-links). Renders an
 * `<Outlet />` so the nested sub-routes can mount their own page content:
 *
 *   - summaries.index    → /summaries          (the all-agents summary view)
 *   - summaries.$agent   → /summaries/$agent   (per-agent detail page)
 *
 * Unlike Review & Analysis, this parent does NOT redirect to a default
 * agent. The bare /summaries URL is the canonical landing — practitioners
 * see all 13 agent cards, then drill into individual agents from the
 * sidebar or by clicking a card.
 */

import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute(
  "/_app/_auth/dashboard/_layout/jobs/$jobId/summaries",
)({
  component: SummariesLayout,
});

function SummariesLayout() {
  return <Outlet />;
}
